import React from 'react';
import { StyledTableRowColumn } from '../../table/StyledTable';
import { Currency } from 'ui-toolkit';
import { IEscrowActualIncomingCheckData } from 'types/accounting/data/IEscrowActualIncomingCheckData';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { StyledSelectedIcon, StyledTableRow } from './MatchedActualStyles';
import { getDateString } from '../../../../../ui-toolkit/utilities/getDateString';

interface IMatchActualCheckDepositRowProps {
  checkDeposit: IEscrowActualIncomingCheckData;
  selectedId?: string;
  setSelectedId: (detail: string | undefined) => void;
}

export const MatchActualCheckDepositRow: React.FC<IMatchActualCheckDepositRowProps> = ({
  checkDeposit,
  selectedId,
  setSelectedId,
}) => {
  const detail = JSON.stringify(checkDeposit.checkDetail);
  return (
    <>
      <StyledTableRow
        columnsLength={6}
        onClick={() => {
          selectedId === checkDeposit.id ? setSelectedId(undefined) : setSelectedId(checkDeposit.id);
        }}
        data-test-id={'actual-check-deposit-row'}
      >
        <StyledTableRowColumn>{getDateString(`LLLL d, yyyy`, checkDeposit.completedAtDate)}</StyledTableRowColumn>
        <StyledTableRowColumn>{checkDeposit.checkIdentifier}</StyledTableRowColumn>
        <StyledTableRowColumn>{detail}</StyledTableRowColumn>
        <StyledTableRowColumn>
          <Currency value={checkDeposit.amountCents} valueIsCents />
        </StyledTableRowColumn>
        <StyledTableRowColumn>
          <Currency value={checkDeposit.unmatchedAmountCents} valueIsCents />
        </StyledTableRowColumn>
        <StyledTableRowColumn>
          {selectedId === checkDeposit.id && (
            <StyledSelectedIcon icon={faCircleCheck} size={'lg'} aria-label={'selectedrow'} />
          )}
        </StyledTableRowColumn>
      </StyledTableRow>
    </>
  );
};
